import React from "react";
import { ReactComponent as ExpandMore } from "../assets/icons/expand_more.svg";
import { ReactComponent as Linked } from "../assets/icons/link.svg";
import { ReactComponent as LinkedOff } from "../assets/icons/link_off.svg";
import { ReactComponent as RadioButtonChecked } from "../assets/icons/radio_button_checked.svg";
import { ReactComponent as RadiButtonUnchecked } from "../assets/icons/radio_button_unchecked.svg";
import { ReactComponent as UsersIcon } from "../assets/icons/users.svg";
import { ReactComponent as VolumeOff } from "../assets/icons/volume_off.svg";
import { ReactComponent as VolumeOn } from "../assets/icons/volume_up.svg";
import { getTimeExpr } from "../utils";

import "../ChatHeader.css";

export default function ChatHeader(props) {
  const {
    recipient,
    setChatScreenVisable,
    linkToClientHandler,
    userInfo,
    volumeOn,
    setVolumeOn,
    showUsers,
    setShowUsers,
  } = props;

  return (
    <div className="chatheader elegant-header">
      <button
        className="close-button"
        onClick={() => setChatScreenVisable(false)}
      >
        <ExpandMore className="close-icon" />
      </button>
      <div className="chatheader-container">
        {recipient ? (
          <>
            <span className="recipient-status">
              {recipient.online ? (
                <RadioButtonChecked className="status-icon" />
              ) : (
                <RadiButtonUnchecked className="status-icon inactive" />
              )}
            </span>
            <span className="recipient-name">{recipient.name}</span>
            <span className="recipient-business">{recipient.businessName}</span>
            <span className="recipient-lastseen">
              {recipient.lastSeen && getTimeExpr(new Date(recipient.lastSeen))}
            </span>
          </>
        ) : (
          <span className="connect-message">
            Bir müşteriye bağlanmaya çalışın!
          </span>
        )}
      </div>

      <div className="header-buttons-container">
        <button className="linkbutton" onClick={() => setVolumeOn((v) => !v)}>
          {!volumeOn ? (
            <VolumeOff className="header-icon volume-icon" />
          ) : (
            <VolumeOn className="header-icon volume-icon active" />
          )}
        </button>
        <button className="linkbutton" onClick={() => setShowUsers((u) => !u)}>
          <UsersIcon
            className="header-icon user-icon"
            fill={!showUsers ? "#2994b2" : "#dd7777"}
          />
        </button>
        {recipient && (
          <button className="linkbutton" onClick={linkToClientHandler}>
            {userInfo.client?._id === recipient._id ? (
              <Linked className="header-icon link-icon active" />
            ) : (
              <LinkedOff className="header-icon link-icon" />
            )}
          </button>
        )}
      </div>
    </div>
  );
}
